interface SvgBookmarkFilledProps {
  className?: string;
  width?: number | string;
  height?: number | string;
}
export default function SvgBookmarkFilled(props: SvgBookmarkFilledProps) {
  return <svg width={24} height={24} viewBox="0 0 24 24" fill="none" role="img" {...props}><path d="M19.5 22.499L12 18.709L4.5 22.499V3.0498C4.50011 2.19392 5.19392 1.50011 6.0498 1.5H17.9502C18.8061 1.50011 19.4999 2.19392 19.5 3.0498V22.499Z" fill="currentColor" /></svg>;
}